import type { TOC } from '@ember/component/template-only';

import type { RateGroupRow } from '../rate-groups-accordion';

interface TdRateGroupNameSignature {
  Args: {
    row: RateGroupRow;
  };
}

/* Gives the name an id so the row's controls can include it in their accessible
   name, telling screen reader users which rate group each control belongs to. */
const TdRateGroupName = <template>
  <span id="rate-group-{{@row.rateGroupId}}-name">{{@row.name}}</span>
</template> satisfies TOC<TdRateGroupNameSignature>;

export default TdRateGroupName;
